import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBookmark: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"bookmark, banner, flag, tag"} maskId="square-filled-radius-0-stroke-1-IconBookmark"><path d="M4 2V22.3333L12 18.0667L20 22.3333V2H4Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconBookmark;
